import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ForumIcon(props: IconProps) {
    return <Icon {...props} iconKey={"forum"}/>
}
